import { render, staticRenderFns } from "./AddNode.vue?vue&type=template&id=55013924&scoped=true"
import script from "./AddNode.vue?vue&type=script&lang=js"
export * from "./AddNode.vue?vue&type=script&lang=js"
import style0 from "./AddNode.vue?vue&type=style&index=0&id=55013924&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55013924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55013924')) {
      api.createRecord('55013924', component.options)
    } else {
      api.reload('55013924', component.options)
    }
    module.hot.accept("./AddNode.vue?vue&type=template&id=55013924&scoped=true", function () {
      api.rerender('55013924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleFlow/src/components/AddNode.vue"
export default component.exports